// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/public/css/class.css
// module id = 92
// module chunks = 49